import {VoiceEffect, OctaveEffect} from 'effects/midi/chords/ChordEffects.js';
import {ThickEffect, FlatEffect, SplitEffect} from 'effects/midi/chords/TransformEffects.js';
import AltEffect from 'effects/midi/scripting/AltEffect.js';
import AltNEffect from 'effects/midi/scripting/AltNEffect.js';

export const VOICE_OPTIONS = [
    {label: "1st", value: 1},
    {label: "2nd", value: 2},
    {label: "3rd", value: 3},
    {label: "4th", value: 4},
    {label: "5th", value: 5},
    {label: "6th", value: 6},
    {label: "7th", value: 7},
    {label: "8th", value: 8},
    {label: "9th", value: 9},
    {label: "10th", value: 10},
    {label: "11th", value: 11},
    {label: "12th", value: 12},
    {label: "13th", value: 13},
];

export const FLOW_OPTIONS = [
    {label: "Alternate", value: "Alternate"},
    {label: "Split", value: "Split"},
];

export const TRANSFORM_OPTIONS = [
    {label: "Thick", value: "Thick"},
    {label: "Flat", value: "Flat"},
    {label: "Octave", value: "Octave"},
];

export const initializeVoiceEffect = (track, value) => {
    return new VoiceEffect(track, value);
};

export const initializeTransformEffect = (track, name) => {
    switch (name) {
    case "Octave":
        return new OctaveEffect(track);
    case "Flat":
        return new FlatEffect(track);
    case "Thick":
        return new ThickEffect(track);
    }
};

export const initializeFlowEffect = (track, name) => {
    switch (name) {
    case "Alternate":
        return new AltEffect(track);
    case "Split":
        return new SplitEffect(track);
    }
};

